export default "__VITE_ASSET__naOPAfcW__"